<template>
	<div>
		<div class="content_wrap">
			<div class="warp">
				<div class="password_main">
					<div class="password_main_top ft24">
						<span class="registTitle">机构开发者注册 </span><span class="login_top_txt ft14 fr">已有账号？<a href="#/login">立即登录</a></span>
					</div>
					<div class="step_status step1"></div>
					<div>
						<div class="password_item clearfix">
							<label class="password_item_l"><i>*</i>机构名称：</label>
							<div class="info_item password_item_r">
								<input v-model='OrganizationName' type="text" placeholder="请输入您的机构全称" />
							</div>
						</div>
						
						<div class="password_item clearfix">
							<label class="password_item_l"><i>*</i>联系电话：</label>
							<div class="info_item password_item_r">
								<input v-model="phone" type="text" placeholder="请输入您的联系电话，用于接收重要通知" />
							</div>
						</div>
						<div class="password_item clearfix">
							<label class="password_item_l"><i>*</i>企业邮箱：</label>
							<div class="info_item password_item_r">
								<input v-model="email" type="text" placeholder="请输入您的企业邮箱，用于接收通知" />
							</div>
						</div>
						<!--<div class="password_item clearfix">
							<label class="password_item_l"><i>*</i>验证码：</label>
							<div class="info_item password_item_r">
								<div id="slider"></div>
							</div>
						</div>

						<div class="password_item clearfix">
							<label class="password_item_l"><i>*</i>短信验证码：</label>
							<div class="info_item password_item_r">
								<input v-model="SmsCode" type="text" placeholder="请输入您的短信验证码">
								<a href="javascript:;" class="yam_btn" @click="smsVerification" v-text="seconds">获取短信验证码</a>
							</div>
						</div>-->

					</div>
					<div class="password_main_btns">
						<a class="blue_btn" @click="next">下一步</a>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: 'firstStep',
		data() {
			return {
//				OrganizationName: sessionStorage.getItem('OrganizationName'), //机构名称
//				email: sessionStorage.getItem('email'), //企业邮箱
//				phone: sessionStorage.getItem('phone'), //联系电话
				OrganizationName: 'e32324244', //机构名称
				email: '1312332@13.com', //企业邮箱
				phone: '15801132206', //联系电话
				
			}
		},
		
		methods: {
			
			next() {
				let baseParms = {
					OrganizationName: this.OrganizationName,
					email: this.email,
					phone: this.phone
				}
				if(this.check.calibration(baseParms)) {
					sessionStorage.setItem('OrganizationName', this.OrganizationName)
					sessionStorage.setItem('email', this.email)
					sessionStorage.setItem('phone', this.phone)
					this.$router.push('/register/SecondStep')
				}
			}
		}
	}
</script>

<style lang="scss">
	.step1 {
		background: url(../../assets/images/regist_step1.jpg) no-repeat;
		background-size: 100%;
	}

	.info_item input{
		padding-left: 5px;
	}
	   
</style>


// WEBPACK FOOTER //
// src/components/_register/FirstStep.vue